export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_763_CLOSE': 'Close',
    '_11191_INTELLIGENT_COACH_ASSIST_GPS': 'Intelligent Coach Assist GPS',
    '_11192_MINIMIZE': 'Minimize',
    '_11193_MAXIMIZE': 'Maximize'
};
